/**
 * Cloudinary delivery URLs for product images, without the Cloudinary SDK —
 * the delivery URL format is stable and this is the only piece the apps need.
 * Framework-free so the planner frontend and the admin portal build the same
 * URL for the same public id; each app supplies its own cloud name from env.
 */
/**
 * Delivery URL for a Cloudinary public id, e.g. `doors/security/final/security_sb`.
 * `f_auto,q_auto` lets Cloudinary negotiate format and quality per browser.
 * No version segment is pinned, so re-uploaded images serve fresh. When no
 * cloud name is configured, or the id is already an absolute URL, the input
 * passes through untouched so local dev keeps working.
 */
export function cloudinaryImageUrl(imageId, cloudName, options = {}) {
    if (!imageId || !cloudName || /^(https?:)?\/\//.test(imageId)) {
        return imageId;
    }
    const transforms = ['f_auto', 'q_auto'];
    if (options.width) {
        transforms.push(`w_${options.width}`);
    }
    if (options.height) {
        transforms.push(`h_${options.height}`);
    }
    const publicId = imageId.replace(/^\//, '');
    return `https://res.cloudinary.com/${cloudName}/image/upload/${transforms.join(',')}/${publicId}`;
}
/** Handing variants of a colour render, per `data/cloudinary-images/naming-rules.md`. */
export function handingImageIds(colourImageId) {
    return { left: `${colourImageId}_left`, right: `${colourImageId}_right` };
}
//# sourceMappingURL=cdn.js.map